<template>
    <div id="auth">
        <form id="subscribeForm" class="form">
            <img id="logo" src="@/assets/logo.svg" alt="" />
            <p>
                Thank you for signing up to Lesson Pro, to complete your subscription follow the
                link below.
            </p>

            <div v-if="products && products[0] && products[0].id">
                <!-- Its android billing v4 -->

                <button
                    :disabled="busy"
                    v-for="product in products"
                    :key="product.id"
                    @click.prevent="subscribe(product)"
                    class="button dark mb10"
                    type="button"
                >
                    {{
                        busy
                            ? "Please wait..."
                            : product.title.replace("(Lesson Pro)", "") +
                              " " +
                              product.priceFormatted +
                              " per month "
                    }}
                </button>
            </div>
            <div v-if="products && products[0] && products[0].itemId">
                <!-- Its android billing v6 -->

                <button
                    :disabled="busy"
                    v-for="product in products"
                    :key="product.itemId"
                    @click.prevent="subscribe(product)"
                    class="button dark mb10"
                    type="button"
                >
                    {{
                        busy
                            ? "Please wait..."
                            : product.localizedTitle.replace("(Lesson Pro)", "") +
                              " " +
                              product.priceFormatted +
                              " per month "
                    }}
                </button>
            </div>
            <div v-else-if="products && products[0] && products[0].productIdentifier">
                <button
                    :disabled="busy"
                    v-for="product in products"
                    :key="product.productIdentifier"
                    @click.prevent="subscribe(product)"
                    class="button dark mb10"
                    type="button"
                >
                    {{
                        busy
                            ? "Please wait..."
                            : product.localizedDescription.replace("(Lesson Pro)", "") +
                              " " +
                              product.priceFormatted +
                              " per month "
                    }}
                </button>
            </div>
            <div v-else-if="env === 'development'">
                <button
                    :disabled="busy"
                    @click.prevent="subscribeTest()"
                    class="button dark mb10"
                    type="button"
                >
                    {{ busy ? "Please wait..." : "Subscribe (test)" }}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import Cookie from "js-cookie";
export default {
    name: "susbcribe",
    data() {
        return {
            oWebViewInterface: window.nsWebViewInterface,
            busy: false,
            env: process.env.NODE_ENV,
        };
    },
    computed: {
        products() {
            return this.$store.state.subscriptions;
        },
        user() {
            return this.$store.state.user;
        },
        compProducts() {
            if (this.user.type == "pro") {
                return this.products.filter((item) => {
                    return item.productIdentifier == "com.lessonpro.application.pro";
                });
            } else {
                return this.products.filter((item) => {
                    return item.productIdentifier == "com.lessonpro.application.player";
                });
            }
        },
    },
    created() {
        this.oWebViewInterface.on("cantsubscribe", () => {
            this.busy = false;
        });

        this.oWebViewInterface.on("subscribedToApp", (api_token) => {
            this.$router.push("/home");
            if (api_token) {
                Cookie.set(process.env.VUE_APP_AUTH_COOKIE_NAME, api_token);
                this.$router.push({ name: "Home" });
            }
        });
    },
    methods: {
        subscribe(product) {
            this.busy = true;
            this.oWebViewInterface.emit("subscribeToProduct", {
                product: product,
                user_id: this.$store.state.user.id,
            });
        },
        subscribeTest() {
            this.busy = true;
            this.$store.state.user.subscribed = 1;
            this.$router.push({ name: "Home" });
        },
    },
};
</script>

<style lang="scss">
#subscribeForm {
    p {
        color: white;
        line-height: 1.4;
        text-align: center;
        margin-bottom: 40px;
    }
}
</style>
